import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import { updateLocalStorage } from './updateLocalStorage';

export const deleteProfileImage = (doc: CoverLetterDocumentType): void => {
  const profileImage = {
    id: doc.profileImage?.id,
    delete: true,
  };

  updateLocalStorage(`fileAttachments`, null);
  updateLocalStorage(`profileImage`, profileImage);
};
